export default {
  en: {
    social: {
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn",
    },
    language: {
      english: "English",
      korean: "Korean",
      japanese: "Japanese",
      german: "German",
      spanish: "Spanish",
      portuguese: "Portuguese",
    },
    dates: {
      month: "month",
      Jan: "Jan",
      Feb: "Feb",
      Mar: "Mar",
      Apr: "Apr",
      May: "May",
      Jun: "Jun",
      Jul: "Jul",
      Aug: "Aug",
      Sep: "Sep",
      Oct: "Oct",
      Nov: "Nov",
      Dec: "Dec",
      January: "January",
      February: "February",
      March: "March",
      April: "April",
      June: "June",
      July: "July",
      August: "August",
      September: "September",
      October: "October",
      November: "November",
      December: "December",
    },
    measurements: {
      kilograms: "kilograms",
    },
  },
  es: {
    social: {
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn",
    },
    language: {
      english: "Inglés",
      korean: "Coreano",
      japanese: "Japonés",
      german: "Alemán",
      spanish: "Español",
    },
    dates: {
      month: "mes",
      Jan: "Ene.",
      Feb: "Feb.",
      Mar: "Mar.",
      Apr: "Abr.",
      May: "May.",
      Jun: "Jun.",
      Jul: "Jul.",
      Aug: "Ago.",
      Sep: "Sept.",
      Oct: "Oct.",
      Nov: "Nov.",
      Dec: "Dic.",
      January: "Enero",
      February: "Febrero",
      March: "Marzo",
      April: "Abril",
      May: "Mayo",
      June: "Junio",
      July: "Julio",
      August: "Agosto",
      September: "Septiembre",
      October: "Octubre",
      November: "Noviembre",
      December: "Diciembre",
    },
    measurements: {
      kilograms: "kilogramos",
    },
  },
  de: {
    social: {
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn",
    },
    language: {
      english: "Englisch",
      korean: "Koreanisch",
      japanese: "Japanisch",
      german: "Deutsch",
      spanish: "Spanisch",
      portuguese: "Portugiesisch",
    },
    dates: {
      month: "Monatlich",
      Jan: "Jan",
      Feb: "Feb",
      Mar: "Mär",
      Apr: "Apr",
      May: "Mai",
      Jun: "Jun",
      Jul: "Jul",
      Aug: "Aug",
      Sep: "Sep",
      Oct: "Okt",
      Nov: "Nov",
      Dec: "Dez",
      January: "Januar",
      February: "Februar",
      March: "März",
      April: "April",
      June: "Juni",
      July: "Juli",
      August: "August",
      September: "September",
      October: "Oktober",
      November: "November",
      December: "Dezember",
    },
    measurements: {
      kilograms: "Kilogramm",
    },
  },
  ja: {
    social: {
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn",
    },
    language: {
      english: "English",
      korean: "한국어",
      japanese: "日本語",
      german: "Deutsch",
      spanish: "Español",
    },
    dates: {
      month: "月",
      Jan: "1月",
      Feb: "2月",
      Mar: "3月",
      Apr: "4月",
      May: "5月",
      Jun: "6月",
      Jul: "7月",
      Aug: "8月",
      Sep: "9月",
      Oct: "10月",
      Nov: "11月",
      Dec: "12月",
      January: "1月",
      February: "2月",
      March: "3月",
      April: "4月",
      June: "6月",
      July: "7月",
      August: "8月",
      September: "9月",
      October: "10月",
      November: "11月",
      December: "12月",
    },
    measurements: {
      kilograms: "キログラム",
    },
  },
  pt: {
    social: {
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn",
    },
    language: {
      english: "Inglês",
      german: "Alemão",
      spanish: "Espanhol",
      korean: "Coreano",
      japanese: "Japonês",
      portuguese: "Português",
    },
    dates: {
      month: "mês",
      Jan: "Jan",
      Feb: "Fev",
      Mar: "Mar",
      Apr: "Abr",
      Jun: "Jun",
      Jul: "Jul",
      Aug: "Ago",
      Sep: "Set",
      Oct: "Out",
      Nov: "Nov",
      Dec: "Dez",
      January: "Janeiro",
      February: "Fevereiro",
      March: "Março",
      April: "Abril",
      May: "Maio",
      June: "Junho",
      July: "Julho",
      August: "Agosto",
      September: "Setembro",
      October: "Outubro",
      November: "Novembro",
      December: "Dezembro",
    },
    measurements: {
      kilograms: "quilogramas",
    },
  },
  ko: {
    social: {
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn",
    },
    language: {
      english: "영어",
      german: "독일어",
      spanish: "스페인어",
      korean: "한글",
      japanese: "일본어",
      portuguese: "포르투갈",
    },
    dates: {
      month: "월",
      Jan: "1월",
      Feb: "2월",
      Mar: "3월",
      Apr: "4월",
      Jun: "6월",
      Jul: "7월",
      Aug: "8월",
      Sep: "9월",
      Oct: "10월",
      Nov: "11월",
      Dec: "12월",
      January: "1월",
      February: "2월",
      March: "3월",
      April: "4월",
      May: "5월",
      June: "6월",
      July: "7월",
      August: "8월",
      September: "9월",
      October: "10월",
      November: "11월",
      December: "12월",
    },
    measurements: {
      kilograms: "kg",
    },
  },
};
